import { Button, Box, IconButton, Tooltip, Typography } from "@mui/material";
import OrganisationTable from "./OrganisationTable";
import { useNavigate } from "react-router-dom";
import { Add, HelpOutline } from "@mui/icons-material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import LogoutContainer from "../Layout/LogoutContainer";
import { HeaderStyle } from "../Common/styles/header";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { openHelp } from "../../Redux/reducers/helpSlice";
import { platformAdminPermissions } from "../../utils/roles";

const Organisations = () => {
  const navigate = useNavigate();
  const { t: sidebarT } = useTranslation("sidebar");
  const dispatch = useAppDispatch();
  const { platformPermissions } = useAppSelector((state) => state.user);
  const canViewPlatform = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.viewPlatform),
    [platformPermissions],
  );
  return (
    <Box>
      <Box
        sx={{
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box>
      </Box>
      <Box sx={HeaderStyle}>
        <Typography fontSize={20} fontWeight="medium" color="text.primary">
          Organisation
        </Typography>

        <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => navigate("/app/organisation/builder/new")}
          >
            Create Organisation
          </Button>
          {canViewPlatform && (
            <Tooltip title={sidebarT("HELP_TOOLTIP")}>
              <IconButton onClick={() => dispatch(openHelp("organisation"))} size="small">
                <HelpOutline />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
      <Box sx={{ p: 3, height: "calc(100vh - 144px)", overflow: "auto" }}>
        <OrganisationTable />
      </Box>
    </Box>
  );
};

export default Organisations;
